import Cookies from 'universal-cookie';
import { COOKIE_KEY } from '../constants';
const requestContextEventHandler = ({
  ctx
}) => {
  const {
    req
  } = ctx;
  if (!req) return;
  const cookies = req.headers.cookie ? new Cookies(req.headers.cookie) : new Cookies();
  if (cookies.get(COOKIE_KEY)) {
    ctx.disableSsr = true;
  }
};
export default requestContextEventHandler;
//# sourceMappingURL=request-context-event-handler.js.map